import React from 'react';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import { BusinessArea } from '../../../../Enums/BusinessArea';
import { getBusinessAreaByChannel } from '../../../../Helpers/AgentHelper';
import ActiveAgentMenu from './Menu/ActiveAgentsMenu';
import { isAgentActive } from '../../../../Helpers/AgentHelper';
import './Styles.css';
import CreateAgentButton from './CreateAgentButton';
import { canAgentNameBeSet, canCommissionEnabledBeSet } from '../../Functions';
import { useLegalUnitName } from '../../../../Helpers/CustomHooks';
import { canShowAgentAddressInTable } from './Functions';
import { getFormattedAddress } from '../../../../Helpers/AddressHelper';
import { Ui24Check } from '@ids/react-icons';
import { LegalUnit } from '../../../../Enums/LegalUnit';

const ActiveAgents = ({ team, areBrokerFunctionsAvailable }) => {
  const activeAgents = team?.agents?.filter(isAgentActive);
  const legalUnitName = useLegalUnitName(team);

  return (
    <div className="teamPage_activeAgents_container">
      {activeAgents?.length > 0 && (
        <>
          <div
            className={`common-table-row ${
              legalUnitName === LegalUnit.Denmark
                ? 'teamPage-activeAgents-tableRow-denmark'
                : 'teamPage-activeAgents-tableRow'
            } headerRow`}>
            <div>{formatMessage(Messages.common_agentCode)}</div>
            <div>{formatMessage(Messages.common_costCenter)}</div>
            <div>{formatMessage(Messages.common_externalSalesCode)}</div>
            {canAgentNameBeSet(legalUnitName) && <div>{formatMessage(Messages.common_name)}</div>}
            <div>{formatMessage(Messages.common_additionalName)}</div>
            <div>{formatMessage(Messages.common_activationDate)}</div>
            <div>{formatMessage(Messages.activeAgents_isAddressInherited)}</div>
            <div>{formatMessage(Messages.activeAgents_isDefaultAgent)}</div>
            {canCommissionEnabledBeSet(legalUnitName) && <div>{formatMessage(Messages.activeAgents_commission)}</div>}
            <div></div>
          </div>

          {activeAgents.map((agent, index) => (
            <div
              className={`common-table-row ${
                legalUnitName === LegalUnit.Denmark
                  ? 'teamPage-activeAgents-tableRow-denmark'
                  : 'teamPage-activeAgents-tableRow'
              } ${index % 2 === 1 ? 'common-table-evenRow' : ''}`}
              key={index}>
              <div>{agent.code}</div>
              <div>{agent.costCenter?.name}</div>
              <div>{agent.externalSalesCode ? agent.externalSalesCode : '—'}</div>
              {canAgentNameBeSet(legalUnitName) && <div>{agent.name}</div>}
              {getBusinessAreaByChannel(agent.channel) === BusinessArea.Commercial ? (
                <div>{agent.additionalName}</div>
              ) : (
                <div>{formatMessage(Messages.activeAgents_notApplicable)}</div>
              )}
              <div>{agent.validFrom}</div>
              <div>
                {canShowAgentAddressInTable(legalUnitName, agent)
                  ? getFormattedAddress(agent.address)
                  : agent.addressIsInherited && <Ui24Check />}
              </div>
              <div>{agent.isDefaultAgentCode && <Ui24Check />}</div>
              {canCommissionEnabledBeSet(legalUnitName) && <div>{agent.commissionEnabled && <Ui24Check />}</div>}

              <ActiveAgentMenu agent={agent} areBrokerFunctionsAvailable={areBrokerFunctionsAvailable} />
            </div>
          ))}
        </>
      )}

      <CreateAgentButton team={team} />
    </div>
  );
};

export default ActiveAgents;
